import React from 'react'
import './MenuProducts.scss'
import MenuDropdownList from './MenuDropdownList'
import {graphql, useStaticQuery} from 'gatsby'
import MenuDropdownPost from './MenuDropdownPost'
import MenuDropdownLayout from './MenuDropdownLayout'
import {get as _get} from 'lodash'
import * as routes from '../../../constants/routes'
import joinUrl from '../../../helpers/joinUrl'
import {useI18next} from 'gatsby-plugin-react-i18next'

const MenuProducts = () => {
    const {language} = useI18next()

    const {
        allStrapiProduct: {edges: products},
    } = useStaticQuery(
        graphql`
            query productMenuQuery {
                allStrapiProduct(sort: {order: ASC}) {
                    edges {
                        node {
                            id
                            strapiId
                            title
                            subtitle
                            locale
                            icon {
                                image {
                                    childImageSharp {
                                        gatsbyImageData(width: 30, placeholder: NONE, layout: FIXED)
                                    }
                                }
                            }
                            page {
                                path
                            }
                        }
                    }
                }
            }
        `
    )

    const productsInLanguage = products.filter(({node}) => node.locale === language)

    const menuItems = productsInLanguage.map((product) => {
        const path = _get(product, 'node.page.path')

        return {
            id: product.node.id,
            title: product.node.title,
            subtitle: product.node.subtitle,
            image: product.node.icon ? product.node.icon.image : null,
            href: joinUrl(routes.PRODUCTS, path),
        }
    })

    return (
        <MenuDropdownLayout>
            <MenuDropdownList items={menuItems} allPath={routes.PRODUCTS} />
            <MenuDropdownPost menu={'products'} />
        </MenuDropdownLayout>
    )
}

export default MenuProducts
